import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent() {
    }
    TabGeneralComponent.prototype.ngOnInit = function () {
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
